<template>
<div class="content">
  <div class="columns">
    <div class="column is-1">
      <ContentMenu />
    </div>
    <div class="column">
      <div class="box" style="min-height : 71vh;">
        <slot>Content</slot>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ContentMenu from './ContentMenu.vue'

export default {
    name: 'Content',
    components: {ContentMenu}
}
</script>

<style scoped>
.column {
    min-width: 300px;
}
</style>
